import { nextTick } from 'vue';
import { Modal, ChipsInput } from 'mdb-ui-kit';

import request from 'utils/request';
import utils from 'utils/utils';
import Swal from 'sweetalert2/dist/sweetalert2.js';

var add_modal;
var edit_modal;
var chips_input;

export function showEditModal(list, index) {
    // 編集中のindexを保持
    this.list = list;
    this.index = index;
    // ノードを複写
    this.node = Object.create(list[index]);

    if (!edit_modal) {
        const mdl = document.getElementById('edit_memory_modal');
        edit_modal = new Modal(mdl);
    }

    // request.clearErrors('memory_form');

    nextTick(() => {
        const elmChips = document.querySelector('.chips-tags');
        if (elmChips) {
            const values = [];
            if (this.node.tags) {
                this.node.tags.forEach(tag => {
                    values.push({ tag: tag });
                });
            }

            if (elmChips.classList.contains('chips')) {
                // 再利用
                elmChips.classList.remove('chips');
                elmChips.innerHTML = null;
            }

            chips_input = new ChipsInput(elmChips, {
                initialValues: values,
                labelText: 'タグ',
            });
        }

        edit_modal.show();
    });
}

export function addTagItem(tag) {
    const elmChips = document.querySelector('.chips-tags');
    if (elmChips) {
        const elmList = elmChips.querySelectorAll('span.text-chip');
        const selected_tags = [];
        elmList.forEach(elm => {
            selected_tags.push(elm.innerText);
        });

        const elmChipsInput = elmChips.querySelector('input.chips-input');
        if (elmChipsInput) {
            if (!selected_tags.includes(tag)) {
                elmChipsInput.value = tag;
                elmChipsInput.focus();
            }
        }
    }
}

export async function saveEdit() {
    utils.loading(true, 0);

    const data = await request.getParam('memory_form');

    // タグの取得
    const tags = [];
    if (chips_input) {
        chips_input.allChips.forEach(elm => {
            const elmText = elm.querySelector('.text-chip');
            if (elmText) {
                const text = elmText.innerText;
                if (!tags.includes(text)) {
                    tags.push(text);
                    data.append('tags[]', text);
                }
            }
        });
    }

    request.post('/api/save-memory', data)
        .then(res => {
            const response = res.data;

            if (edit_modal) {
                edit_modal.hide();
            }

            if (response.node_image) {
                this.getList();
            } else {
                this.list[this.index].node_category = this.node.node_category;
                this.list[this.index].name = this.node.name;
                this.list[this.index].free_memo = this.node.free_memo;
                this.list[this.index].tags = tags;

                this.environment = response.environment;
            }
        })
        .catch(res => {
            request.showErrorResponse(res, 'memory_form');
        })
        .finally(() => {
            utils.loading(false);
        });
}

export function deleteMemory(node_id, listFunction = null) {
    Swal.fire({
        title: '確認',
        html: 'このメモリーを削除しますか？',
        icon: 'question',
        showCancelButton: true,
        cancelButtonText: 'いいえ',
        confirmButtonText: 'はい',
    }).then(result => {
        if (result.isConfirmed) {
            const data = {
                node_id: node_id,
                weight: 0,
            };
            utils.loading(true, 0);
            request.post('/api/save-memory', data)
                .then(res => {
                    const response = res.data;
                    if (edit_modal) {
                        edit_modal.hide();
                    }
                    if (typeof listFunction === 'function') {
                        listFunction();
                    }
                })
                .catch(res => {
                    request.showErrorResponse(res, 'memory_form');
                })
                .finally(() => {
                    utils.loading(false);
                });
        }
    });
}

/**
 *
 * 一括メモリー（URLを一括追加のモーダル表示
 *
 */
export function showAddModal() {
    if (!add_modal) {
        const mdl = document.getElementById('add_memory_modal');
        add_modal = new Modal(mdl);
    }
    add_modal.show();
}

/**
 *
 * 一括メモリー実行
 *
 * @returns {Promise<void>}
 */
export async function saveAdd() {
    if (this.url_text != '') {
        utils.loading(true, 0);
        let urls = this.url_text.split('\n');
        urls = urls.filter(Boolean);
        const data = {
            urls: urls,
        };
        this.url_error = false;
        request.post('/api/bulk-memo', data)
            .then(res => {
                const response = res.data;
                if (add_modal) {
                    add_modal.hide();
                }
                if (response.url) {
                    window.location.href = response.url;
                } else {
                    location.reload();
                }
            })
            .catch(res => {
                const response = res.response;
                const status = response.status ? response.status : 200;
                if (status == 422) {
                    this.url_error = true;
                }else{
                    request.showErrorResponse(res, 'app');
                }
            })
            .finally(() => {
                utils.loading(false);
            });
    }
}
